var map = {
	"./music-instructions.json": 4529,
	"./music-library-intro2024.json": 4530,
	"./music-library-launch2024.json": 4531,
	"./music-progression.json": 4532,
	"./startSourcesAdvanced.json": 4533,
	"./startSourcesSimple.json": 4534,
	"./startSourcesSimple2.json": 4535,
	"./startSourcesTracks.json": 4536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4266;